<template>
  <div class="nodata-wrap" :style="{ width: wrapWidth, height: wrapHeight }">
    <svg
      t="1764813606030"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="10820"
      :width="svgWidth"
      :height="svgHeight"
    >
      <path d="M32.8 979.4a480.2 42.2 0 1 0 960.4 0 480.2 42.2 0 1 0-960.4 0Z" fill="#BFBFBF" p-id="10821"></path>
      <path
        d="M139.2 856.1h639.4c1.1 0 2.3-0.1 3.4-0.2 1.1 0.1 2.3 0.2 3.4 0.2v-0.4c32.3-3.4 57.6-30.8 57.6-64.1V172.2h108V67.9c0-32.3-24-59.1-55-63.7v-0.7c-1.6 0-3.1 0.1-4.7 0.2-1.6-0.1-3.1-0.2-4.7-0.2v0.8c-0.1 0-0.3 0-0.4 0.1v-0.9H205c-35.5 0-64.4 28.9-64.4 64.4v601.3H75v122.4c0 35.5 28.8 64.4 64.2 64.5z m752-840.7c26.9 2.4 48.1 25 48.1 52.5v92.6h-96.1V67.9c0-27.5 21.1-50.1 48-52.5z m-739 52.5c0-29.1 23.7-52.8 52.8-52.8h654c-14.2 10-24.2 25.5-26.8 43.5h-0.7v733c0 27.9-21.9 50.8-49.4 52.6-27.5-1.8-49.4-24.6-49.4-52.6l0.2-120.5h-9.7v-1.9h-571V67.9z m-65.5 613h634.6l-0.2 110.7c0 21.8 10.9 41.1 27.6 52.8H139.3c-29-0.1-52.6-23.8-52.6-52.8V680.9z"
        fill="#BFBFBF"
        p-id="10822"
      ></path>
      <path
        d="M382.6 268.9c0-17.5-14.3-31.8-31.8-31.8S319 251.4 319 268.9s14.3 31.8 31.8 31.8 31.8-14.3 31.8-31.8zM350.8 289c-11.1 0-20.1-9-20.1-20.1s9-20.1 20.1-20.1c11.1 0 20.1 9 20.1 20.1s-9 20.1-20.1 20.1zM636.3 237.1c-17.5 0-31.8 14.3-31.8 31.8s14.3 31.8 31.8 31.8 31.8-14.3 31.8-31.8-14.3-31.8-31.8-31.8z m0 51.9c-11.1 0-20.1-9-20.1-20.1s9-20.1 20.1-20.1c11.1 0 20.1 9 20.1 20.1s-9 20.1-20.1 20.1zM353.6 478.5c-2.5 2-2.9 5.7-0.8 8.2 2 2.5 5.7 2.9 8.2 0.8 5.7-4.6 140.6-112.3 271.5-0.1 1.1 0.9 2.5 1.4 3.8 1.4 1.6 0 3.3-0.7 4.4-2 2.1-2.4 1.8-6.1-0.6-8.2-138.4-118.6-285.1-1.3-286.5-0.1z"
        fill="#BFBFBF"
        p-id="10823"
      ></path>
    </svg>
    <span>{{ $t('lang.OtherModule.k003') }}</span>
  </div>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    wrapWidth: {
      type: String,
      default: '100%',
    },
    wrapHeight: {
      type: String,
      default: '400px',
    },
    svgWidth: {
      type: Number,
      default: 64,
    },
    svgHeight: {
      type: Number,
      default: 64,
    },
  },
}
</script>

<style scoped>
.nodata-wrap {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  span {
    font-size: 12px;
    margin-top: 10px;
  }
}
</style>
